// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {

  production: false,
  firebase: {
    apiKey: "AIzaSyDKp7CnzepODuuQQ3lJnyqNyefLGpkAoD0",
    authDomain: "orange-sky-dev.firebaseapp.com",
    databaseURL: "https://orange-sky-dev.firebaseio.com",
    projectId: "orange-sky-dev",
    storageBucket: "orange-sky-dev.appspot.com",
    messagingSenderId: "534558591602"
  },

  googleapis:{
    client_id:'534558591602-456aia70eebnc2robc4mf7rsvpjgm79p.apps.googleusercontent.com',
    client_secret:'E4RQP1wZE2CsNic05AgV2I31',
    redirect_url:'https://orange-sky-dev.firebaseapp.com/__/auth/handler'
  },

  functionsURL: 'https://us-central1-orange-sky-dev.cloudfunctions.net',
  stripePublishable: 'pk_test_JWburQjqAAxuonQuJA61vnZa'

};


// WEBPACK FOOTER //
// ./src/environments/environment.ts